export default "__VITE_ASSET__Dyi2ilwl__"